import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { fromReservation, fromLang } from 'store/selectors';

const DropDownFieldRequiredItem = styled.li`
    white-space: pre-wrap;
    padding: 8px;
    margin: 5px 15px 5px 15px;
    cursor: pointer;
    text-align: left;
    border-bottom: 1px solid #f2acac;
    &:hover{
      opacity:0.75;
    }

    span{
      display: block;
      white-space: pre-wrap;
    }
`;
class GuestWarningComponent extends React.Component {

  onClick = () => {
    const { id, departureId } = this.props;
    let scrollToPos = 0;
    const guestElement = document.getElementById(`${departureId}-${id}`);
    const guestElementTopPosition = guestElement.offsetParent.offsetTop;
    const guestElementHeight = guestElement.offsetHeight;
    scrollToPos = guestElementTopPosition - ((guestElementHeight * 2) || 150);
    const chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    const firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    const edge = navigator.userAgent.toLowerCase().indexOf('edge') > -1;
    if (edge) {
      window.scrollTo(0, scrollToPos);
    } else if (chrome || firefox) {
      window.scrollTo({ top: scrollToPos, behavior: 'smooth' });
    } else {
      window.scroll(0, scrollToPos);
    }
  }

  render() {
    const { number, isPassportFieldsComplete, incompletePassportFieldsText, missingFieldLabels, guestLabel, wrongFormatLabel, missingLabel, validationErrors } = this.props;
    const uniquemissingFieldLabels = missingFieldLabels.filter(el => !validationErrors.includes(el));

    const errorFieldsHtml = [];

    const missingFieldsHtml = uniquemissingFieldLabels.map(label => (
      <li>{label} {missingLabel}</li>
    ));
    const validationFieldsHtml = validationErrors.map(label => (
      <li>{label} - {wrongFormatLabel}</li>
    ));

    errorFieldsHtml.push(missingFieldsHtml);
    errorFieldsHtml.push(validationFieldsHtml);

    if (!isPassportFieldsComplete) {
      errorFieldsHtml.push(<li>{incompletePassportFieldsText}</li>);
    }

    return (
      <DropDownFieldRequiredItem
        role="button"
        tabIndex={-1}
        onClick={this.onClick}
      ><strong>{guestLabel} # {number}</strong> <ul>{errorFieldsHtml}</ul></DropDownFieldRequiredItem>
    );
  }
}


const mapStateToProps = (state, { id, departureId, missingFields }) => ({
  number: fromReservation.getGuestNumberOnDeparture(state, id, departureId),
  isPassportFieldsComplete: fromReservation.isPassportFieldsComplete(state, id),
  missingFieldLabels: missingFields.map(field => fromLang.t(state, field)),
  validationErrors: fromReservation.getValidationErrors(state).flatMap(g => g.fields).map(field => fromLang.t(state, field)),
});

GuestWarningComponent.propTypes = {
  id: PropTypes.string.isRequired,
  departureId: PropTypes.string.isRequired,
  number: PropTypes.number,
  isPassportFieldsComplete: PropTypes.bool,
  incompletePassportFieldsText: PropTypes.string,
  missingFields: PropTypes.array,
  missingFieldLabels: PropTypes.array,
  validationErrors: PropTypes.array,
  guestLabel: PropTypes.string,
  wrongFormatLabel: PropTypes.string,
  missingLabel: PropTypes.string,
};

export default connect(mapStateToProps)(GuestWarningComponent);



// WEBPACK FOOTER //
// ./src/components/organisms/Header/GuestWarning.js